(() => {
  const examplesByLanguage = {
    ka: [
      'აკრილის საღებავი',
      'ტილო დაგრუნტული',
      'ფუნჯები',
      'სკეჩბუქი',
      'მარკერები',
      'აკვარელი',
      'ზეთის საღებავი',
      'პასტელი',
      'ფერადი ფანქრები',
      'პალიტრა'
    ],
    en: [
      'Acrylic paint',
      'Primed canvas',
      'Brushes',
      'Sketchbook',
      'Markers',
      'Watercolor',
      'Oil paint',
      'Pastels',
      'Colored pencils',
      'Palette'
    ],
    ru: [
      'Акриловая краска',
      'Грунтованный холст',
      'Кисти',
      'Скетчбук',
      'Маркеры',
      'Акварель',
      'Масляная краска',
      'Пастель',
      'Цветные карандаши',
      'Палитра'
    ]
  };

  const clearLabelsByLanguage = {
    ka: 'ძიების გასუფთავება',
    en: 'Clear search',
    ru: 'Очистить поиск'
  };

  const viewCartLabelsByLanguage = {
    ka: 'კალათის ნახვა',
    en: 'View cart',
    ru: 'Перейти в корзину'
  };

  const addToCartLabelsByLanguage = {
    ka: 'კალათაში დამატება',
    en: 'Add to cart',
    ru: 'Добавить в корзину'
  };

  const instantSectionLabelsByLanguage = {
    popular: {
      ka: 'პოპულარული შემოთავაზებები',
      en: 'Popular suggestions',
      ru: 'Популярные предложения'
    },
    products: {
      ka: 'პროდუქციის ძიება',
      en: 'Product search',
      ru: 'Поиск товаров'
    },
    categories: {
      ka: 'კატეგორიები',
      en: 'Categories',
      ru: 'Категории'
    }
  };

  const resultTabsByLanguage = {
    products: {
      ka: 'პროდუქტები',
      en: 'Products',
      ru: 'Товары'
    },
    categories: {
      ka: 'კატეგორიები',
      en: 'Categories',
      ru: 'Категории'
    },
    pages: {
      ka: 'სტატიები',
      en: 'Articles',
      ru: 'Статьи'
    }
  };

  const resultCountLabelsByLanguage = {
    ka: (count, query) => `ნაჩვენებია ${count} შედეგი "${query}" -სთვის`,
    en: (count, query) => `Showing ${count} results for "${query}"`,
    ru: (count, query) => `Показано результатов: ${count} по запросу "${query}"`
  };

  const sortOptionsByLanguage = {
    ka: [
      'შესაბამისობით',
      'ა - ზ',
      'ზ - ა',
      'თარიღი: ახლიდან ძველებამდე',
      'თარიღი: ძველებიდან ახლებამდე',
      'ფასი: ზრდადობით',
      'ფასი: კლებადობით',
      'ფასდაკლება: კლებადობით',
      'ბესთსელერები'
    ],
    en: [
      'Relevance',
      'A - Z',
      'Z - A',
      'Date: New to old',
      'Date: Old to new',
      'Price: Low to high',
      'Price: High to low',
      'Discount: High to low',
      'Bestsellers'
    ],
    ru: [
      'По релевантности',
      'А - Я',
      'Я - А',
      'Дата: новые сначала',
      'Дата: старые сначала',
      'Цена: по возрастанию',
      'Цена: по убыванию',
      'Скидка: по убыванию',
      'Хиты продаж'
    ]
  };

  const sortAriaLabelsByLanguage = {
    ka: 'სორტირების ვარიანტები',
    en: 'Sort options',
    ru: 'Варианты сортировки'
  };

  const searchResultsUiTextByKey = {
    price: {
      ka: 'ფასი, GEL',
      en: 'Price, GEL',
      ru: 'Цена, GEL',
      aliases: ['ფასი', 'Price', 'Цена']
    },
    availability: {
      ka: 'ხელმისაწვდომობა',
      en: 'Availability',
      ru: 'Наличие',
      aliases: ['Available', 'Доступность']
    },
    productType: {
      ka: 'პროდუქტის ტიპი',
      en: 'Product type',
      ru: 'Тип товара',
      aliases: ['Product Type', 'Тип продукта']
    },
    tags: {
      ka: 'თეგები',
      en: 'Tags',
      ru: 'Теги',
      aliases: ['Tag', 'Тег']
    },
    collections: {
      ka: 'კოლექციები',
      en: 'Collections',
      ru: 'Коллекции',
      aliases: ['Collection', 'Коллекция']
    },
    discounts: {
      ka: 'ფასდაკლებები',
      en: 'Discounts',
      ru: 'Скидки',
      aliases: ['Discount', 'Sale', 'Скидка', 'Распродажа']
    },
    inStock: {
      ka: 'მარაგში',
      en: 'In stock',
      ru: 'В наличии',
      aliases: ['მარაგშია']
    },
    outOfStock: {
      ka: 'არ არის მარაგში',
      en: 'Out of stock',
      ru: 'Нет в наличии',
      aliases: ['Sold out', 'Unavailable', 'Нет товара']
    },
    filters: {
      ka: 'ფილტრები',
      en: 'Filters',
      ru: 'Фильтры',
      aliases: ['Filter', 'Фильтр']
    },
    clearAll: {
      ka: 'ყველას გასუფთავება',
      en: 'Clear all',
      ru: 'Очистить все',
      aliases: ['Clear All', 'Reset all', 'Сбросить все']
    },
    clear: {
      ka: 'გასუფთავება',
      en: 'Clear',
      ru: 'Очистить',
      aliases: ['Reset', 'Сбросить']
    },
    apply: {
      ka: 'გამოყენება',
      en: 'Apply',
      ru: 'Применить',
      aliases: ['Show results', 'Показать результаты']
    },
    showMore: {
      ka: 'მეტის ჩვენება',
      en: 'Show more',
      ru: 'Показать еще',
      aliases: ['More', 'Показать больше']
    },
    showLess: {
      ka: 'ნაკლების ჩვენება',
      en: 'Show less',
      ru: 'Показать меньше',
      aliases: ['Less', 'Скрыть']
    }
  };

  const searchResultsUiTextSelectors = [
    '#snize_results .snize-product-filters-title',
    '#snize_results .snize-filters-dropdown-title',
    '#snize_results .snize-filter-title',
    '#snize_results .snize-filter-name',
    '#snize_results .snize-filter-label',
    '#snize_results .snize-filters-dropdown-button',
    '#snize_results .snize-in-stock',
    '#snize_results .snize-out-of-stock',
    '#snize_results .snize-clear-all',
    '#snize_results .snize-filter-clear-all',
    '#snize_results .snize-show-more',
    '#snize_results .snize-show-less',
    '#snize_results button',
    '#snize_results a'
  ];

  const tabAriaLabelsByLanguage = {
    ka: label => `${label} ჩანართი`,
    en: label => `${label} tab`,
    ru: label => `Вкладка: ${label}`
  };

  const getLanguageCode = () => {
    const lang = document.documentElement.lang || 'ka';
    return lang.toLowerCase().split('-')[0];
  };

  const getExamples = () => {
    const languageCode = getLanguageCode();
    return examplesByLanguage[languageCode] || examplesByLanguage.ka;
  };

  const getClearLabel = () => {
    const languageCode = getLanguageCode();
    return clearLabelsByLanguage[languageCode] || clearLabelsByLanguage.ka;
  };

  const getViewCartLabel = () => {
    const languageCode = getLanguageCode();
    return viewCartLabelsByLanguage[languageCode] || viewCartLabelsByLanguage.en;
  };

  const getAddToCartLabel = () => {
    const languageCode = getLanguageCode();
    return addToCartLabelsByLanguage[languageCode] || addToCartLabelsByLanguage.en;
  };

  const getLocalizedValue = (source, fallback = 'en') => {
    const languageCode = getLanguageCode();
    return source[languageCode] || source[fallback] || source.ka;
  };

  const isVisible = element => {
    return Boolean(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  };

  const isSearchInputActive = () => {
    const activeElement = document.activeElement;
    return Boolean(
      activeElement &&
      activeElement.matches &&
      activeElement.matches('.site-search-handle input[type="search"]') &&
      activeElement.value.trim().length > 0
    );
  };

  const isSearchaniseInstantOpen = () => {
    return isVisible(document.getElementById('snize-instant-search-results'));
  };

  const syncSearchDimState = () => {
    document.body.classList.toggle('search-ux-dim-active', isSearchInputActive() || isSearchaniseInstantOpen());
  };

  const scheduleSearchDimSync = () => {
    [0, 120, 350].forEach(delay => {
      window.setTimeout(syncSearchDimState, delay);
    });
  };

  const enforceSearchActions = (root = document) => {
    const scope = root.nodeType == Node.ELEMENT_NODE ? root : document;
    const forms = [];

    if (scope.matches && scope.matches('form[data-lumino-search-action]')) {
      forms.push(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('form[data-lumino-search-action]').forEach(form => forms.push(form));
    }

    forms.forEach(form => {
      const action = form.dataset.luminoSearchAction;
      if (action && form.getAttribute('action') != action) {
        form.setAttribute('action', action);
      }
    });
  };

  const submitSearchForm = form => {
    const action = form && form.dataset.luminoSearchAction;
    const input = form && form.querySelector('input[name="q"], input[type="search"]');
    const value = input && input.value && input.value.trim();

    if (!action || !value) {
      return false;
    }

    const url = new URL(action, window.location.origin);
    url.searchParams.set('q', value);
    window.location.href = `${url.pathname}${url.search}`;
    return true;
  };

  const initSearchInput = input => {
    if (!input) {
      return;
    }

    const holder = input.closest('.site-search-handle');
    if (!holder) {
      return;
    }

    holder.querySelectorAll('.search-placeholder-rotator:not([data-search-ux-rotator]), .search-clear-button:not([data-search-ux-clear])').forEach(el => el.remove());

    if (input.dataset.searchUxEnhanced == 'true') {
      return;
    }

    input.dataset.searchUxEnhanced = 'true';
    holder.querySelectorAll('.search-placeholder-rotator, .search-clear-button').forEach(el => el.remove());

    const examples = getExamples();
    const originalPlaceholder = input.dataset.originalPlaceholder || input.getAttribute('placeholder') || input.getAttribute('aria-label') || '';
    input.dataset.originalPlaceholder = originalPlaceholder;

    const rotator = document.createElement('span');
    rotator.className = 'search-placeholder-rotator';
    rotator.dataset.searchUxRotator = 'true';
    rotator.setAttribute('aria-hidden', 'true');
    holder.append(rotator);

    const clearButton = document.createElement('button');
    clearButton.type = 'button';
    clearButton.className = 'search-clear-button';
    clearButton.dataset.searchUxClear = 'true';
    clearButton.setAttribute('aria-label', getClearLabel());
    clearButton.textContent = '×';
    clearButton.hidden = true;
    holder.append(clearButton);

    let exampleIndex = 0;
    let charIndex = 0;
    let deleting = false;
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setRotatorText = () => {
      const example = examples[exampleIndex];
      rotator.textContent = reducedMotion ? example : example.slice(0, charIndex);
    };

    const updateState = () => {
      const hasValue = input.value.trim().length > 0;
      const isFocused = document.activeElement === input;
      const shouldHideRotator = hasValue || isFocused;
      holder.classList.toggle('search-placeholder-rotator--hidden', shouldHideRotator);
      holder.classList.toggle('search-clear-button--visible', hasValue);
      rotator.hidden = shouldHideRotator;
      clearButton.hidden = !hasValue;
      input.setAttribute('placeholder', hasValue || isFocused ? originalPlaceholder : '');
      scheduleSearchDimSync();
    };

    input.addEventListener('focus', updateState);
    input.addEventListener('blur', updateState);
    input.addEventListener('input', updateState);
    input.addEventListener('change', updateState);
    input.addEventListener('keyup', updateState);
    clearButton.addEventListener('mousedown', event => {
      event.preventDefault();
    });
    clearButton.addEventListener('click', () => {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      const searchForm = input.closest('search-form');
      if (searchForm && typeof searchForm.clearSearchResults == 'function') {
        searchForm.clearSearchResults();
      }
      input.focus();
      updateState();
      scheduleSearchDimSync();
    });

    if (reducedMotion) {
      setRotatorText();
    } else {
      const tick = () => {
        const example = examples[exampleIndex];
        let delay = deleting ? 55 : 95;

        if (deleting) {
          charIndex--;
          if (charIndex <= 0) {
            deleting = false;
            exampleIndex = (exampleIndex + 1) % examples.length;
            delay = 260;
          }
        } else {
          charIndex++;
          if (charIndex >= example.length) {
            deleting = true;
            delay = 1100;
          }
        }

        setRotatorText();
        window.setTimeout(tick, delay);
      };

      setRotatorText();
      window.setTimeout(tick, 300);
    }

    updateState();
    [0, 150, 500, 1200].forEach(delay => {
      window.setTimeout(updateState, delay);
    });
    window.addEventListener('pageshow', updateState);
  };

  const searchaniseViewCartButtonSelector = '#snize-instant-search-results .size-button-view-cart, #snize_results .size-button-view-cart';
  const searchaniseAddToCartButtonSelector = '#snize-instant-search-results .snize-add-to-cart-button:not(.size-button-view-cart), #snize_results .snize-add-to-cart-button:not(.size-button-view-cart)';
  const instantSectionLabelKeys = Object.entries(instantSectionLabelsByLanguage).reduce((all, [key, labels]) => {
    Object.values(labels).forEach(label => {
      all[label] = key;
    });
    return all;
  }, {});

  const localizeSearchaniseCartButtons = (root = document) => {
    const scope = root.nodeType == Node.ELEMENT_NODE ? root : document;
    const viewCartButtons = [];
    const addToCartButtons = [];
    const viewCartLabel = getViewCartLabel();
    const addToCartLabel = getAddToCartLabel();

    if (scope.matches && scope.matches(searchaniseViewCartButtonSelector)) {
      viewCartButtons.push(scope);
    }

    if (scope.matches && scope.matches(searchaniseAddToCartButtonSelector)) {
      addToCartButtons.push(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(searchaniseViewCartButtonSelector).forEach(button => viewCartButtons.push(button));
      scope.querySelectorAll(searchaniseAddToCartButtonSelector).forEach(button => addToCartButtons.push(button));
    }

    viewCartButtons.forEach(button => {
      if (button.textContent.trim() != viewCartLabel) {
        button.textContent = viewCartLabel;
      }
      button.setAttribute('aria-label', viewCartLabel);
    });

    addToCartButtons.forEach(button => {
      if (button.textContent.trim() != addToCartLabel) {
        button.textContent = addToCartLabel;
      }
      button.setAttribute('aria-label', addToCartLabel);
    });
  };

  const setImportantStyle = (element, property, value) => {
    if (element) {
      element.style.setProperty(property, value, 'important');
    }
  };

  const searchResultProductSelector = '#snize_results #snize-search-results-grid-mode li.snize-product';

  const updateLabelText = (element, label) => {
    if (!element || element.textContent.trim() == label) {
      return;
    }
    element.textContent = label;
  };

  const normalizeSearchResultsText = text => text.replace(/\s+/g, ' ').trim();

  const getSearchResultsUiTextMap = () => {
    const languageCode = getLanguageCode();
    const labels = new Map();

    Object.values(searchResultsUiTextByKey).forEach(entry => {
      const localizedLabel = entry[languageCode] || entry.en || entry.ka;
      const aliases = [entry.ka, entry.en, entry.ru].concat(entry.aliases || []);

      aliases.forEach(alias => {
        if (alias) {
          labels.set(normalizeSearchResultsText(alias), localizedLabel);
        }
      });
    });

    return labels;
  };

  const updateElementTextPreservingChildren = (element, label) => {
    if (!element || normalizeSearchResultsText(element.textContent) == label) {
      return;
    }

    const textNodes = Array.from(element.childNodes).filter(node => {
      return node.nodeType == Node.TEXT_NODE && normalizeSearchResultsText(node.textContent).length > 0;
    });

    if (!element.children.length || !textNodes.length) {
      element.textContent = label;
    } else {
      textNodes[0].textContent = label;
      textNodes.slice(1).forEach(node => node.remove());
    }

    if (element.matches && element.matches('button, a, [role="button"]')) {
      element.setAttribute('aria-label', label);
    }
  };

  const updateTabText = (link, label) => {
    if (!link) {
      return;
    }

    const currentText = Array.from(link.childNodes)
      .filter(node => node.nodeType == Node.TEXT_NODE)
      .map(node => node.textContent)
      .join('')
      .trim();
    const nextAriaLabel = getLocalizedValue(tabAriaLabelsByLanguage)(label);

    if (currentText == label && link.getAttribute('aria-label') == nextAriaLabel) {
      return;
    }

    const count = link.querySelector('span');
    Array.from(link.childNodes).forEach(node => {
      if (node.nodeType == Node.TEXT_NODE) {
        node.remove();
      }
    });
    link.insertBefore(document.createTextNode(label), count || null);
    link.setAttribute('aria-label', nextAriaLabel);
  };

  const localizeSearchaniseText = (root = document) => {
    const scope = root.nodeType == Node.ELEMENT_NODE ? root : document;
    const languageCode = getLanguageCode();

    const localizeInstantLabel = label => {
      const key = instantSectionLabelKeys[label.textContent.trim()];
      if (key) {
        updateLabelText(label, instantSectionLabelsByLanguage[key][languageCode] || instantSectionLabelsByLanguage[key].en);
      }
      if (languageCode == 'ka') {
        label.style.setProperty('font-family', '"BPG Nino Mtavruli Bold", "BPG Nino Mtavruli", sans-serif', 'important');
        label.style.setProperty('font-weight', '400', 'important');
        label.style.setProperty('letter-spacing', '0', 'important');
        label.style.setProperty('line-height', '1.25', 'important');
      }
    };

    if (scope.matches && scope.matches('#snize-instant-search-results .snize-label')) {
      localizeInstantLabel(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('#snize-instant-search-results .snize-label').forEach(localizeInstantLabel);
    }

    const uiTextMap = getSearchResultsUiTextMap();
    const uiTextElements = new Set();

    searchResultsUiTextSelectors.forEach(selector => {
      if (scope.matches && scope.matches(selector)) {
        uiTextElements.add(scope);
      }
      if (scope.querySelectorAll) {
        scope.querySelectorAll(selector).forEach(element => uiTextElements.add(element));
      }
    });

    uiTextElements.forEach(element => {
      const replacement = uiTextMap.get(normalizeSearchResultsText(element.textContent));
      if (replacement) {
        updateElementTextPreservingChildren(element, replacement);
      }
    });

    updateTabText(document.querySelector('#snize_results .snize-main-panel-controls-products'), getLocalizedValue(resultTabsByLanguage.products));
    updateTabText(document.querySelector('#snize_results .snize-main-panel-controls-categories'), getLocalizedValue(resultTabsByLanguage.categories));
    updateTabText(document.querySelector('#snize_results .snize-main-panel-controls-pages'), getLocalizedValue(resultTabsByLanguage.pages));

    const resultHeader = document.querySelector('#snize_results .snize-search-results-header');
    if (resultHeader) {
      const count = resultHeader.querySelector('b') && resultHeader.querySelector('b').textContent.trim();
      const query = resultHeader.querySelector('.snize-no-products-found-link') && resultHeader.querySelector('.snize-no-products-found-link').textContent.trim();
      if (count && query) {
        updateLabelText(resultHeader, getLocalizedValue(resultCountLabelsByLanguage)(count, query));
      }
    }

    const sortOptions = getLocalizedValue(sortOptionsByLanguage);
    document.querySelectorAll('#snize_results .snize-main-panel-dropdown-button').forEach(button => {
      const currentIndex = sortOptionsByLanguage.ka.indexOf(button.textContent.trim());
      const localizedIndex = sortOptions.indexOf(button.textContent.trim());
      const index = currentIndex > -1 ? currentIndex : localizedIndex;
      if (index > -1) {
        updateLabelText(button, sortOptions[index]);
      }
      button.setAttribute('aria-label', getLocalizedValue(sortAriaLabelsByLanguage));
    });

    document.querySelectorAll('#snize_results .snize-main-panel-dropdown ul li').forEach((item, index) => {
      if (sortOptions[index]) {
        updateLabelText(item, sortOptions[index]);
      }
    });
  };

  const initAll = (root = document) => {
    enforceSearchActions(root);
    if (!root.querySelectorAll) {
      localizeSearchaniseCartButtons(root);
      localizeSearchaniseText(root);
      return;
    }
    root.querySelectorAll('.site-search-handle input[type="search"]').forEach(initSearchInput);
    localizeSearchaniseCartButtons(root);
    localizeSearchaniseText(root);
  };

  if (document.readyState == 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  window.addEventListener('load', () => initAll());
  [0, 300, 900, 1800, 3200].forEach(delay => {
    window.setTimeout(() => {
      enforceSearchActions();
    }, delay);
  });
  window.addEventListener('pageshow', scheduleSearchDimSync);
  document.addEventListener('submit', event => {
    const form = event.target && event.target.closest && event.target.closest('form[data-lumino-search-action]');
    if (form && submitSearchForm(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (
      event.key == 'Enter' &&
      !event.isComposing &&
      event.target &&
      event.target.closest &&
      event.target.closest('form[data-lumino-search-action]')
    ) {
      const form = event.target.closest('form[data-lumino-search-action]');
      if (submitSearchForm(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key == 'Escape') {
      window.setTimeout(syncSearchDimState, 120);
    }
  });

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      localizeSearchaniseCartButtons(mutation.target);
      localizeSearchaniseText(mutation.target);
      enforceSearchActions(mutation.target);
      scheduleSearchDimSync();
      mutation.addedNodes.forEach(node => {
        if (node.nodeType != Node.ELEMENT_NODE) {
          return;
        }
        if (node.matches && node.matches('.site-search-handle input[type="search"]')) {
          initSearchInput(node);
        }
        initAll(node);
      });
    });
  });

  observer.observe(document.body, {
    attributeFilter: ['action', 'class'],
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
  });

  const isSearchaniseCartButton = target => {
    return target.closest && target.closest(
      '#snize-instant-search-results .snize-add-to-cart-button, #snize_results .snize-add-to-cart-button'
    );
  };

  const refreshCartQuietly = () => {
    if (typeof window.refreshCart == 'function') {
      window.refreshCart(false);
    }
  };

  const scheduleSearchaniseCartRefresh = () => {
    [650, 1600].forEach(delay => {
      window.setTimeout(() => {
        refreshCartQuietly();
        localizeSearchaniseCartButtons();
      }, delay);
    });
  };

  document.addEventListener('click', event => {
    if (isSearchaniseCartButton(event.target)) {
      scheduleSearchaniseCartRefresh();
    }
  }, true);

  const isCartAddUrl = url => {
    return typeof url == 'string' && url.indexOf('/cart/add') > -1;
  };

  if (!window.searchUxCartBridgeReady) {
    window.searchUxCartBridgeReady = true;

    const originalFetch = window.fetch;
    if (typeof originalFetch == 'function') {
      window.fetch = function(...args) {
        const request = args[0];
        const url = typeof request == 'string' ? request : request && request.url;
        const response = originalFetch.apply(this, args);

        if (isCartAddUrl(url)) {
          response.then(result => {
            if (result && result.ok) {
              scheduleSearchaniseCartRefresh();
            }
          }).catch(() => {});
        }

        return response;
      };
    }

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      this.searchUxCartAdd = isCartAddUrl(url);
      return originalOpen.call(this, method, url, ...args);
    };

    XMLHttpRequest.prototype.send = function(...args) {
      if (this.searchUxCartAdd) {
        this.addEventListener('loadend', () => {
          if (this.status >= 200 && this.status < 300) {
            scheduleSearchaniseCartRefresh();
          }
        });
      }

      return originalSend.apply(this, args);
    };
  }
})();

